import {Injectable} from '@angular/core'
import * as firebase from 'firebase/app'
import {AngularFireDatabase} from 'angularfire2/database'
import {UserService} from '../../user/user.service'

const MESSAGESCOLLECTION: string = 'messages'

@Injectable()
export class ChatService {
  constructor(private db: AngularFireDatabase, public user: UserService) {}

  getMessages(creative) {
    let file = creative.file || creative
    return this.db.list([MESSAGESCOLLECTION, file.folder, file.dbkey].join('/'))
  }

  postMessage(creative, text) {
    let user = {
      username: this.user.current.username,
      uid: this.user.current.uid,
    }

    let id = this.db.createPushId()

    return this.getMessages(creative).set(id, {
      id: id,
      type: 'text',
      user: user,
      text: text,
      date: firebase.database.ServerValue.TIMESTAMP,
      status:
        text
          .trim()
          .toLowerCase()
          .replace(/[^a-zA-Z0-9]+/g, '') == 'approved'
          ? 'done'
          : 'flag',
    })
  }

  updateMessage(creative, messageid, message) {
    let file = creative.file || creative
    this.db
      .object(
        [MESSAGESCOLLECTION, file.folder, file.dbkey, messageid].join('/')
      )
      .update(message)
  }

  approveCreative(creative) {
    creative.approved = !creative.approved
    this.db
      .object(['folders', creative.folder, 'files', creative.dbkey].join('/'))
      .update({approved: creative.approved})
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/chat/chat.service.ts